import React from 'react';

import { CARD_THEMES } from './card_theme';
import { IndexCard, getIndexCards } from './index_card';

import type { ActivitySearchToolCall } from '../types';

interface ActivityCardsProps {
  toolCalls: ActivitySearchToolCall[];
}

export function ActivityCards({ toolCalls }: ActivityCardsProps) {
  return (
    <>
      {getIndexCards(toolCalls).map(index => (
        <IndexCard
          index={index}
          key={index.path}
          label="activities"
          pageName="Activities"
          theme={CARD_THEMES.activity}
        />
      ))}
    </>
  );
}
